import { render, staticRenderFns } from "./PaginationProductList.vue?vue&type=template&id=8016e8a0"
import script from "./PaginationProductList.vue?vue&type=script&lang=js"
export * from "./PaginationProductList.vue?vue&type=script&lang=js"
import style0 from "./PaginationProductList.vue?vue&type=style&index=0&id=8016e8a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports